'use strict';
import * as $j_app$002epages$002e$002dDocument$002dTemplates$002dCreate$002dPage$0024$002dCreate$002dForm$002dSend$002dAction$0024$0024anon$00243 from "./app.pages.-Document-Templates-Create-Page$-Create-Form-Send-Action$$anon$3.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_pages_DocumentTemplatesCreatePage$CreateFormSendAction(templateNameValidatedRx, userSignal) {
  this.Yd = null;
  this.Ye = null;
  this.Yd = templateNameValidatedRx;
  this.Ye = userSignal;
}
export { $c_Lapp_pages_DocumentTemplatesCreatePage$CreateFormSendAction as $c_Lapp_pages_DocumentTemplatesCreatePage$CreateFormSendAction };
$p = $c_Lapp_pages_DocumentTemplatesCreatePage$CreateFormSendAction.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_pages_DocumentTemplatesCreatePage$CreateFormSendAction;
/** @constructor */
function $h_Lapp_pages_DocumentTemplatesCreatePage$CreateFormSendAction() {
}
export { $h_Lapp_pages_DocumentTemplatesCreatePage$CreateFormSendAction as $h_Lapp_pages_DocumentTemplatesCreatePage$CreateFormSendAction };
$h_Lapp_pages_DocumentTemplatesCreatePage$CreateFormSendAction.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_pages_DocumentTemplatesCreatePage$CreateFormSendAction)) {
    var x = this.Yd;
    var x$2 = x$0.Yd;
    if ((x === x$2)) {
      var x$3 = this.Ye;
      var x$4 = x$0.Ye;
      return (x$3 === x$4);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 2;
});
$p.t = (function() {
  return "CreateFormSendAction";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.Yd;
  }
  if ((n === 1)) {
    return this.Ye;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "templateNameValidatedRx";
  }
  if ((n === 1)) {
    return "userSignal";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.Vt = (function(validatedData, unvalidatedData) {
  return new $j_app$002epages$002e$002dDocument$002dTemplates$002dCreate$002dPage$0024$002dCreate$002dForm$002dSend$002dAction$0024$0024anon$00243.$c_Lapp_pages_DocumentTemplatesCreatePage$CreateFormSendAction$$anon$3(unvalidatedData, this);
});
function $isArrayOf_Lapp_pages_DocumentTemplatesCreatePage$CreateFormSendAction(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kj)));
}
export { $isArrayOf_Lapp_pages_DocumentTemplatesCreatePage$CreateFormSendAction as $isArrayOf_Lapp_pages_DocumentTemplatesCreatePage$CreateFormSendAction };
var $d_Lapp_pages_DocumentTemplatesCreatePage$CreateFormSendAction = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_pages_DocumentTemplatesCreatePage$CreateFormSendAction, "app.pages.DocumentTemplatesCreatePage$CreateFormSendAction", ({
  kj: 1,
  fU: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_pages_DocumentTemplatesCreatePage$CreateFormSendAction as $d_Lapp_pages_DocumentTemplatesCreatePage$CreateFormSendAction };
//# sourceMappingURL=app.pages.-Document-Templates-Create-Page$-Create-Form-Send-Action.js.map
